import { gql } from '@apollo/client';

export const USERS_QUERY = gql`
  query Users($input: FindUserInput!) {
    users(findUserInput: $input) {
      id
      fullName
      role
      email
      phone
      admin
      birthDate
      hireDate
      jobTitle
      ssn
      personal
      officeId
      
      
      fax
      emergency
      referrerId
      referredDate
      avatar
      invited
      active
      documents {
        id
        name
        url
        extension
        size
        createdAt
      }
    }
  }
`;